import { BaseService } from '@flint/framework';

export default class GetTopic extends BaseService {
  constructor() {
    super("FETCHING_TOPIC_LIST", 'TopicListStore', true);
  }

  handleEvent(eventName, bookId) {
    return this.getClient('vetService').get(`/admin-api/topics/${bookId}`);
  }
}